import {
  Button,
  DatePickerWithInput,
  HeadingGroup,
  ModalLayout,
  NavGroup,
  OffCanvasLayout,
  Pagination,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import Style from "../../Billings/staffBilling.module.scss";
import { Link } from "react-router-dom";
import useDeliveryChallan from "./useDeliveryChallan";
import DeliveryChallanForm from "./DeliveryChallanForm";
import { Table } from "../../Global/Table";
import DeliveryChallanPrint from "../DeliveryChallan/DeliveryChellanPrint/DeliveryChellan";

const DeliveryChallan = () => {
  const {
    date,
    tabNavs,
    activeTab,
    reduxState,
    isTab1,
    paginationOptions,
    currentData,
    isFetching,
    tableFields,
    showEditModal,
    queryState,
    showOffcanvas,
    handleSearch,
    handleSort,
    handlePageSize,
    handlePagination,
    handleEditColumnsClick,
    refetch,
    getRow,
    handlePrepare,
    handleEdit,
    handleCloseOffcanvas,
    handleCancel,
    handleStatusChange,
    cancelReason,
    cancelReasonError,
    handleCancelReasonChange,
    handlePrintChellan,
    chellanRef,
    loadingChellan,
    handleDateChange,
  } = useDeliveryChallan();

  return (
    <div>
      <HeadingGroup title={"Delivery Challan"} className={`pro-mb-4`} />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className={`${Style.main_container}`}>
          <NavGroup navigations={tabNavs} type={"type-2"} Link={Link} />
        </div>
        <div className="col-auto pro-pt-3">
          <div className="row gx-2 gy-2 flex-fill">
            <div className={`col-auto`}>
              <div className="input-wrap">
                <input
                  type="text"
                  onChange={handleSearch}
                  placeholder="Search this table"
                  className={`pro-input icon-r lg ${Style.search_table}`}
                />
                <span className="pro-icon">
                  {<span className="material-symbols-outlined">search</span>}
                </span>
              </div>
            </div>

            <div className={`col-auto`}>
              <DatePickerWithInput
                CalendarOutlineIcon={
                  <span className="material-symbols-outlined">
                    calendar_month
                  </span>
                }
                range={true}
                initialValue={date}
                onDateChange={handleDateChange}
              ></DatePickerWithInput>
            </div>
          </div>
        </div>

        <Table
          multiSelect={isTab1}
          data={(currentData?.data?.data || []).map((item) => ({
            ...item,
            disable: item?.status === "CANCELED",
          }))}
          // data={currentData?.data?.data || []}
          uniqueID={isTab1 ? "id" : "_id"}
          fields={tableFields}
          SortIcon={<FaSort />}
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          perpage={queryState?.currentPageSize}
          assignable={true}
          assignText={
            isTab1
              ? "Create Delivery Challan"
              : loadingChellan
                ? "Printing Challan...."
                : "Print Challan"
          }
          assignIcon={
            <span className="material-symbols-outlined">
              {isTab1 ? "list_alt" : "print"}
            </span>
          }
          handleAssign={isTab1 ? handlePrepare : handlePrintChellan}
          showCheckBox={true}
          editable={!isTab1}
          deletable={!isTab1}
          deleteText={"Cancel"}
          handleDelete={handleCancel}
          deleteIcon={
            <span class="material-symbols-outlined">change_circle</span>
          }
          editIcon={<span className="material-symbols-outlined">edit</span>}
          handleEdit={handleEdit}
          clear={queryState?.clear}
        />
        {currentData?.data?.data?.length > 0 && (
          <Pagination
            currentPage={queryState?.currentPage}
            totalPageCount={Math.ceil(
              currentData?.data?.total_count / queryState?.currentPageSize,
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={currentData?.data?.fields}
              moduleId={currentData?.data?.module_id}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={reduxState?.showConfirmationModal}
          handleClose={handleCancel}
          backdrop="static"
        >
          <div className="pro-m-5">
            <h5 className="pro-ttl pro-mb-1">
              Are you sure you want to cancel the selected GLI?
            </h5>
            <p className="pro-mb-4">
              This will update the delivery challan status.
            </p>
            <div className="input-wrap pro-mb-4">
              <label
                htmlFor="cancelreason"
                className="pro-font-sm pro-mb-1 pro-fw-medium"
              >
                What is the reason for cancellation?
              </label>
              <textarea
                id="cancelreason"
                name="cancelreason"
                rows={4}
                className={`pro-input lg ${cancelReasonError ? " error" : ""}`}
                value={cancelReason}
                onChange={handleCancelReasonChange}
              />
              {cancelReasonError && (
                <span className="error-text">{cancelReasonError}</span>
              )}
            </div>
            <div className="col-12 pro-d-flex pro-justify-end pro-mt-4">
              <Button
                className={"pro-btn-link lg pro-px-5"}
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button
                className={"pro-btn-primary lg pro-ms-3"}
                type="submit"
                onClick={handleStatusChange}
              >
                Submit
              </Button>
            </div>
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={showOffcanvas}
          handleClose={handleCloseOffcanvas}
          title={isTab1 ? "Create Delivery Challan" : "Edit Delivery Challan"}
          closeIcon={<span className="material-symbols-outlined">close</span>}
        >
          <DeliveryChallanForm />
        </OffCanvasLayout>
        <div
          style={{
            position: "fixed",
            opacity: "0",
            visibility: "hidden",
            height: "0",
            width: "0",
          }}
        >
          <DeliveryChallanPrint chellanRef={chellanRef} isChallanUpload />
        </div>
      </div>
    </div>
  );
};

export default DeliveryChallan;
